/*
 * @Author: caiqin.xie
 * @since: 2023-08-16 18:26:30
 * @lastTime: 2023-08-30 09:36:01
 * @LastEditors: caiqin.xie
 * @message: 内容类型常量
 */

// 博客
export const BLOGTYPE = '1686671431647711232';
// 新闻
export const NEWSTYPE = '1686671492951658496';
export const VIDEOTYPE = '1686671545707614208';
// 服务政策
export const AFTERSERVICETYPE = '1686671665656320000';
// FAQ
export const FAQTYPE = '1686671713756598272';
// FAQ内容类型
export const CONTENTTYPEID = '1686671713756598272';
// Popular forums
export const POPULARFORUMSTYPE = '1686671713756598273';
// 产品配件
export const ACCESSORYTYPE = '1686671713756598276';
// 隐私条款
export const PRIVACY = '1686671713756598277'
// 关于我们-获奖信息
export const AWARDTYPE = '1686671713756598274'
// 关于我们-媒体评价
export const MEDIATYPE = '1686671713756598275'
